import { a125, a128, a149, a159, a188, a716, a733 } from "Components/Api/RootApiPath";

export const fetchInvoiceList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a188, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch invoice list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchVendorsList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a149, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchAllRDPurchaseList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a159, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchAllCategoryList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a125, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchAllProductTypes = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a128, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchLotAuditReports = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a733, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};
